import { getField, updateField } from 'vuex-map-fields'

export const state = {
    accountForm: {
        account_status: 1,
        company_name: '',
        first_name: '',
		last_name: '',
		bldg_apt_name: '',
		street: '',
		city: '',
        country: {},
        zone_name: {},
        zip_code: '',
        contact_no: '',
        phone_number: '',
        email: '',
        company_email: '',
        subscription_start: '',
        subscription_end: '',
        user_allocation: '',
        categories: [],
        prebuilt_default: [],
        price: '',
        password: '',
        password_confirmation: '',
        country_code: {},
        company_type: {},
        partnerCountry: {},
        partner: {}
    },

    formLoading: false,
    isUpdateAccount: false,
    hasFormChangeChecker: {},
    hasFormChanged: false,
    isFormComplete: false,
    formPage: 1,
    isPageOneComplete: false
}

export const actions = {
}

export const mutations = {
    updateField,

    clearForm () {
        state.accountForm = {
            account_status: 1,
            company_name: '',
            first_name: '',
			last_name: '',
			bldg_apt_name: '',
			street: '',
			city: '',
            country: {},
            zone_name: {},
            zip_code: '',
            contact_no: '',
            phone_number: '',
            email: '',
            company_email: '',
            subscription_start: '',
            subscription_end: '',
            user_allocation: '',
            categories: [],
            prebuilt_default: [],
            price: '',
            password: '',
            password_confirmation: '',
            country_code: {},
            company_type: {},
            partnerCountry: {},
            partner: {}
        }

        state.hasFormChangeChecker = {}
        state.hasFormChanged = false
        state.isFormComplete = false
        state.isUpdateAccount = false
        state.formPage = 1
    },

    setFormChangedChecker() {
        state.hasFormChangeChecker = {
            ...JSON.parse(JSON.stringify(state.accountForm))
        }
    },

    hasFormChanged() {
        const accountForm = state.accountForm
        const formChecker = state.hasFormChangeChecker
        const stringifyObj = (obj) => JSON.stringify(obj)

        for (const property in accountForm) {
            const formProperty = accountForm[property]
            const formCheckerProperty = formChecker[property]

            if (typeof accountForm[property] === 'object') {
                const stringObjForm = stringifyObj(formProperty)
                const stringObjFormChecker = stringifyObj(formCheckerProperty)

                if (stringObjForm !== stringObjFormChecker) {
                    state.hasFormChanged = true
                    return
                }

            } else {
                if (formProperty !== formCheckerProperty) {
                    state.hasFormChanged = true
                    return
                }
            }
        }
    },

    isPageOneComplete(state, payload) {
        state.isPageOneComplete = true
        
        
        let requiredFields = [
            'company_name', 'first_name', 'last_name',
			'email', 'contact_no','country', 'zone_name',
            'bldg_apt_name', 'street', 'city', 'zip_code'
        ]

        if (payload !== 'accountRequest') {
			const otherFields = ['password', 'password_confirmation']
			requiredFields = [...requiredFields, ...otherFields]
		}

        for (let field of requiredFields) {
            const formProperty = state.accountForm[field]
            if (formProperty === '' || (
                formProperty && formProperty.constructor === Object
                && !Object.keys(formProperty).length
            )) {
                state.isPageOneComplete = false

                return
            }
        }
    },

    isFormComplete (state, isDistributor = false) {
        state.isFormComplete = true
        const accountForm = state.accountForm
        const nonRequiredProperty = isDistributor ?
			[
				'partnerCountry',
				'partner',
				'company_type',
				'categories',
                'prebuilt_default',
				'bldg_apt_name',
				'street',
				'city'
			]
            : [
                'categories',
                'prebuilt_default',
                'company_type',
                'phone_number',
                'company_email',
                'partnerCountry',
                'partner'
            ]

        // if (payload !== 'accountRequest') {
        //     const otherFields = ['password', 'password_confirmation']
        //     nonRequiredProperty = [...nonRequiredProperty, ...otherFields]
        // }

        for (const property in accountForm) {
            const formProperty = accountForm[property]
			// if (isDistributor && property === 'company_type') return 

            if (nonRequiredProperty.indexOf(property) === -1) {
                if (
                    formProperty === ''
                    || (
                        formProperty.constructor === Object
                        && !Object.keys(formProperty).length
                    )
                    || (
                        formProperty.constructor === Array
                        && formProperty.length <= 0
                    )
                ) {
                    console.log(property)
                    state.isFormComplete = false

                    return
                }
            }
        }
    }
}

const getters = {
    getField
}

export default {
    state,
    actions,
    mutations,
    getters,
    namespaced: true
}
